import i18n from 'i18next';
import ICU from 'i18next-icu';
import ca from 'i18next-icu/locale-data/ca';
import en from 'i18next-icu/locale-data/en';
import es from 'i18next-icu/locale-data/es';
import fr from 'i18next-icu/locale-data/fr';
import ja from 'i18next-icu/locale-data/ja';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { getLocaleString, getLanguageCode } from 'utilities/locales';
import { getEnv } from 'utilities/environment';

const lazyLoadTranslation = async (locale) => {
  const json = await import(`config/translations/${locale}.json`).then(
    (module) => module.default,
  );

  return json;
};

i18n
  .use(initReactI18next)
  .use(Backend)
  .use(
    new ICU({
      localeData: [ca, en, es, fr, ja],
    }),
  )
  .init({
    lng: getLanguageCode(),
    fallbackLng: 'en',
    ns: [getLocaleString(), 'en'],
    defaultNS: getLocaleString(),
    fallbackNS: 'en',
    debug: getEnv() !== 'production',
    interpolation: {
      escapeValue: false,
      format: (value, format) => {
        if (format === 'uppercase') return value.toUpperCase();
        if (format === 'lowercase') return value.toLowerCase();
        if (format === 'capitalize') {
          return `${value.slice(0, 1).toUpperCase()}${value.slice(1)}`;
        }
        return value;
      },
    },
    backend: {
      backends: [
        resourcesToBackend((_language, locale, callback) => {
          lazyLoadTranslation(locale).then((data) => callback(null, data));
        }),
      ],
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 's'],
    },
  });

export { default } from 'i18next';
